import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { fmtPrice } from "../lib/api";

const stockBadge = (inventory) => {
  const entries = Object.entries(inventory || {});
  if (!entries.length) return null;
  const total = entries.reduce((s, [, v]) => s + v, 0);
  if (total <= 0) return { text: "Sold Out", sold: true };
  const low = entries.filter(([, v]) => v > 0 && v <= 3);
  if (low.length === 1) return { text: `Only ${low[0][1]} left in ${low[0][0]}` };
  if (low.length > 1) return { text: `Low stock · ${low.map(([s]) => s).join(" ")}` };
  if (total <= 10) return { text: `Only ${total} left` };
  return null;
};

export const ProductCard = ({ product, index = 0 }) => (
  <motion.div
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1], delay: (index % 3) * 0.08 }}
    data-testid="product-card"
  >
    <Link to={`/product/${product.slug}`} className="group block">
      <div className="relative overflow-hidden bg-[#E2E4E8] aspect-[3/4]">
        <img
          src={product.image}
          alt={product.name}
          className="w-full h-full object-cover transition-transform duration-[900ms] ease-out group-hover:scale-105"
        />
        <span className="absolute top-4 left-4 label text-[#0B0E14] bg-[#EDEEF1]/80 px-2 py-1">{product.category}</span>
        {(() => {
          const b = stockBadge(product.inventory);
          return b ? (
            <span
              data-testid="stock-badge"
              className={`absolute top-4 right-4 label px-2 py-1 ${b.sold ? "bg-[#0B0E14] text-[#EDEEF1]" : "bg-[#2B6BFF] text-white"}`}
            >
              {b.text}
            </span>
          ) : null;
        })()}
      </div>
      <div className="flex items-start justify-between mt-4 gap-4">
        <div>
          <h3 className="font-serif-display text-xl leading-tight">{product.name}</h3>
          <p className="label text-[#8A8F99] mt-1 link-underline inline-block">View piece</p>
        </div>
        <span className="text-sm mt-1">{fmtPrice(product.price)}</span>
      </div>
    </Link>
  </motion.div>
);
